import { authTypes } from "../../type/auth/auth";
import { PATCH } from "../../../services/api";
import getUniqueDeviceId from "../../../utils/commonFunctions";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";
import axios from "axios";
import { toast } from "react-toastify";

const basicAuth = btoa(
  `${process.env.REACT_APP_AUTH_NAME}:${process.env.REACT_APP_AUTH_PASS}`
);

export const adminLogin = (user, callback, callBackError) => {
  return async (dispatch) => {
    user.device_token =
      "chbdxjbkjsfdfd" + getUniqueDeviceId.getUniqueDeviceId();
    user.device_id = getUniqueDeviceId.getUniqueDeviceId();
    user.device_type = 3;
    user.os = "Linux";
    user.os_version = "22.0";
    user.browser = "chrome";
    try {
      dispatch({
        type: authTypes.POST_SIGN_ADMIN_PENDING,
      });
      const res = await axios.post(
        `${process.env.REACT_APP_API_URI}/${ApiUrl.CLIENT_CREATE_LOGIN}`,
        user,
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );
      if (res?.data?.code === 200) {
        localStorage.setItem("ACCESS_TOKEN", res.data.result.token);
        localStorage.setItem("IS_ADV", Boolean(res.data.result.manage_advt));
        localStorage.setItem("LOGO", res.data.result.logo);
        localStorage.setItem("USER_EMAIL", res.data.result.email);
        localStorage.setItem("USER_NAME", res.data.result.name_en);
        dispatch({
          type: authTypes.POST_SIGN_ADMIN_SUCCESS,
          payload: res.data,
        });
        toast.success(res?.data?.message);
        callback();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      callBackError(error?.response?.data?.message);
    }
  };
};

export const forgotPwd = (data, callback, callBackError) => {
  return async () => {
    const email = {
      email: data.email,
    };
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URI}/${ApiUrl.CLIENT_FORGOT_PASSWORD}`,
        email,
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );

      if (res?.data?.code === 200) {
        localStorage.setItem("FORGOT_TOKEN", res.data.result.token);
        toast.success(res?.data?.message);
        callback();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
};
// export const verifyOtp = (data, callback, callBackError) => {
//   return async () => {
//     const email = {
//       otp: data.otp,
//     };
//     const res = await axios.post(
//       `${process.env.REACT_APP_API_URI}/${ApiUrl.CLIENT_VERIFY_OTP}`,
//       email,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("FORGOT_TOKEN")}`,
//           "x-api-key": process.env.REACT_APP_API_KEY,
//         },
//       }
//     );

//     if (res?.data?.code === 202) {
//       localStorage.setItem("RESET_TOKEN", res.data.result);
//       toast.success(res?.data?.message);
//       callback();
//     } else {
//       toast.error(res?.data?.message);
//     }
//   };
// };

export const verifyOtp = (data, callback, callBackError) => {
  return async () => {
    try {
      const email = {
        otp: data.otp,
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_URI}/${ApiUrl.CLIENT_VERIFY_OTP}`,
        email,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("FORGOT_TOKEN")}`,
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );

      if (res?.data?.code === 202) {
        localStorage.setItem("RESET_TOKEN", res.data.result);
        toast.success(res?.data?.message);
        callback();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.error("otpError", error);
      toast.error(error?.response?.data?.message);
    }
  };
};

export const resetPassword = (values, callback) => {
  return async () => {
    const datas = {
      new_password: values.newPassword,
    };
    const res = await axios.patch(
      `${process.env.REACT_APP_API_URI}/${ApiUrl.CLIENT_RESET_PASSWORD}`,
      datas,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("RESET_TOKEN")}`,
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
      }
    );

    if (res?.data?.code === 201) {
      toast.success(res?.data?.message);
      callback();
    } else {
      toast.error(res?.data?.message);
    }
  };
};

export const changePassword = (values, callback) => {
  return async () => {
    const datas = {
      old_password: values.currentPassword,
      new_password: values.newPassword,
    };
    const res = await PATCH(`${ApiUrl.CLIENT_CHANGE_PASSWORD}`, datas);
    if (res?.data?.code === 200) {
      toast.success(res?.data?.message);
      callback();
    } else {
      toast.error(res?.data?.message);
    }
  };
};


export const changeUserPassword = (values, callback) => {
  return async () => {
    const datas = {
      new_password: values.newPassword,
      // user_id: values.user_id,
    };
    const res = await PATCH(`${ApiUrl.CLIENT_USER_CHANGE_PASSWORD}?user_id=${values.user_id}`, datas);
    if (res?.data?.code === 200) {
      toast.success(res?.data?.message);
      callback();
    } else {
      toast.error(res?.data?.message);
    }
  };
};


// export const logout = () => {
//   return async () => {
//     const res = await POST("admin/auth/logout");
//     toast.success(res?.data?.message);
//     localStorage.removeItem("ACCESS_TOKEN");
//     localStorage.clear();
//     setTimeout(() => {
//       window.location.reload();
//     }, 1000);
//   };
// };
